(() => {
  const popup = document.getElementById('UniqEntryPopup');
  if (!popup) return;

  const DELAY_SECONDS = Number(window.__UNIQ_POP_DELAY__ || 15);
  const DAYS = Number(window.__UNIQ_POP_DAYS__ || 7);
  const STORAGE_KEY = 'snaz_studio_popup_v1';

  const closeEls = popup.querySelectorAll('[data-uniq-pop-close]');
  const form = popup.querySelector('#UniqEntryPopupForm');

  function daysToMs(days) {
    return days * 24 * 60 * 60 * 1000;
  }

  function getState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function setState(value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {}
  }

  function shouldShow() {
    const state = getState();

    if (!state.hideUntil) {
      return true;
    }

    return Date.now() > Number(state.hideUntil);
  }

  function hideForDays() {
    setState({
      hideUntil: Date.now() + daysToMs(DAYS)
    });
  }

  function loadPopupLogo() {
    const logo = popup.querySelector('.uniq-pop__logo[data-src]');

    if (logo && !logo.getAttribute('src')) {
      logo.setAttribute('src', logo.getAttribute('data-src'));
    }
  }

  function openPopup() {
    loadPopupLogo();

    popup.hidden = false;
    popup.style.display = 'block';
    popup.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('uniq-pop-open');

    const emailInput = popup.querySelector('input[type="email"]');

    window.setTimeout(() => {
      if (emailInput) {
        emailInput.focus();
      }
    }, 300);
  }

  function closePopup() {
    popup.hidden = true;
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('uniq-pop-open');

    hideForDays();
  }

  closeEls.forEach((element) => {
    element.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }
  });

  if (form) {
    form.addEventListener('submit', () => {
      hideForDays();
    });
  }

  const successMessage = popup.querySelector('.uniq-pop__success');

  if (successMessage) {
    hideForDays();

    popup.hidden = true;
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');

    return;
  }

  if (shouldShow()) {
    window.setTimeout(() => {
      if (shouldShow()) {
        openPopup();
      }
    }, Math.max(0, DELAY_SECONDS) * 1000);
  }
})();